module.exports = __webpack_public_path__ + "static/media/panelD.d0360fc0.png";